import {TextField, Checkbox} from 'material-ui';

import PropTypes from 'prop-types';
import React from 'react';

import {
  CONTENT_IMAGE,
  CONTENT_MULTIPLE_IMAGE,
  CONTENT_SINGLE_TEXT,
  CONTENT_TEXT,
  CONTENT_CHILDS,
  CONTENT_SNIPPET,
  CONTENT_CHECKBOX,
} from './contentConstants';
import {Label} from '../FormElements';
import ArkEdit from '../ArkEdit';
import ChildsBuilder from './ChildsBuilder';
import MediaPicker from '../MediaPicker/MediaPicker';
import SnippetSelect from './SnippetSelect';

const renderItem = (def, values, changeValue, config, inlineMode, allSnippets) => {
  if (def.type === CONTENT_SINGLE_TEXT) {
    return (
      <TextField
        floatingLabelText={def.title}
        fullWidth
        onChange={({target: {value}}) => changeValue(def.key, value)}
        type="text"
        value={values[def.key] || ''}
      />
    );
  } else if (def.type === CONTENT_TEXT) {
    return (
      <div>
        <Label>{def.title}</Label>
        <ArkEdit
          onChange={value => {
            changeValue(def.key, value);
          }}
          value={values[def.key]}
        />
      </div>
    );
  } else if (def.type === CONTENT_IMAGE) {
    return (
      <MediaPicker
        config={config}
        multiple={false}
        onSelect={medias => {
          if (medias.length > 0) {
            changeValue(def.key, medias[0]);
          } else {
            changeValue(def.key, null);
          }
        }}
        title={def.title}
        type={'image'}
        values={values[def.key] || []}
      />
    );
  } else if (def.type === CONTENT_MULTIPLE_IMAGE) {
    return (
      <MediaPicker
        config={config}
        multiple
        onSelect={medias => {
          changeValue(def.key, medias);
        }}
        title={def.title}
        type={'image'}
        values={values[def.key] || []}
      />
    );
  } else if (def.type === CONTENT_CHILDS) {
    const defaultValues = def.defaultValues || [];
    return (
      <ChildsBuilder
        config={config}
        inlineMode={inlineMode}
        itemConfig={def.config}
        onApplyValues={childs => {
          changeValue(def.key, childs);
        }}
        title={def.title}
        values={values[def.key] || defaultValues}
      />
    );
  } else if (def.type === CONTENT_SNIPPET) {
    return (
      <SnippetSelect
        title={def.title}
        allSnippets={allSnippets.filter(snippet => snippet.type === def.snippetType)}
        selectedSnippets={values[def.key] || []}
        toggleSnippet={snippet => {
          const snippets = values[def.key] || [];
          if (!snippets.length) {
            changeValue(def.key, [...snippets, snippet]);
          } else {
            const tmp = snippets.find(snip => snip._id === snippet._id);
            if (tmp) {
              changeValue(def.key, snippets.filter(snip => snip._id !== snippet._id));
            } else {
              changeValue(def.key, [...snippets, snippet]);
            }
          }
        }}
      />
    );
  } else if (def.type === CONTENT_CHECKBOX) {
    return (
      <Checkbox
        label={def.title}
        checked={values[def.key] || false}
        style={{marginTop: 20, marginBottom: 10}}
        onCheck={() => {
          changeValue(def.key, !(values[def.key] || false));
        }}
      />
    );
  }
};

const ContentBuilder = ({values, changeValue, contentDefinition, config, inlineMode, allSnippets}) => {
  return (
    <div>
      {contentDefinition.map((def, idx) => {
        return <div key={idx}>{renderItem(def, values, changeValue, config, inlineMode, allSnippets)}</div>;
      })}
    </div>
  );
};

ContentBuilder.propTypes = {
  changeValue: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  contentDefinition: PropTypes.array.isRequired,
  inlineMode: PropTypes.bool,
  values: PropTypes.object.isRequired,
};
ContentBuilder.defaultProps = {
  inlineMode: false,
};

export default ContentBuilder;



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/Content/ContentBuilder.js